<template>
  <div>
    <div class="cPagination">
      <!-- start cPaginationContent -->
      <div :class="canSearch ? 'cPaginationContentNew' : 'cPaginationContent'" ref="wrapEle">
        <!-- start 数据列表 -->
        <div ref="overflowEle" slot="content" @touchmove="loadMore">
          <slot name="dataList"></slot>
        </div>
        <!-- end 数据列表 -->

        <!-- start 暂无数据 -->
        <div class="no_data" v-if="data && data.length <= 0 && noMoreImg">
          <img :src="noMoreImg" alt="" />
          <p class="no_more_text">{{ noMoreText }}</p>
          <p class="no_more_btn" v-if="noMoreBtn" @click="$router.push(noMoreUrl)">{{ noMoreBtn }}</p>
        </div>

        <div class="no_data" v-if="data && data.length <= 0 && !noMoreImg">暂无数据</div>
        <!-- end 暂无数据 -->

        <!-- start .more 加载更多 -->
        <div v-if="hasMore" class="more" ref="more">
          <cPartLoading :loading="true"></cPartLoading>
        </div>
        <!-- end .more -->
      </div>
      <!-- end cPaginationContent -->
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
export default {
  props: ['data', 'hasMoreName', 'noMoreImg', 'noMoreUrl', 'noMoreText', 'noMoreBtn', 'module', 'hasMore', 'canSearch'],
  // computed: {
  //   hasMore() {
  //     return this.$store.state[this.module][this.hasMoreName]
  //   }
  // },
  methods: {
    // 加载更多
    // loadMore: window._.debounce(function () {
    loadMore: debounce(function () {
      // 判断是否还有更多分页

      if (this.hasMore) {
        // 判断加载更多按钮是否进入可视区域
        let isMoreSee = window.utils.enterVisualScope(this.$refs.overflowEle, this.$refs.wrapEle, this.$refs.wrapEle)
        if (isMoreSee) {
          this.$emit('morePage')
        }
      }
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
.cPagination {
  width: 100%;
  height: 100%;
  .cPaginationContent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .cPaginationContentNew {
    position: absolute;
    top: 1.3rem;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

// 加载更多
.more {
  position: relative;
}

.no_data {
  text-align: center;
  img {
    display: block;
    margin: 2rem auto 0;
    width: 40%;
  }
  p {
    text-align: center;
  }
  .no_more_text {
    margin-top: 2rem;
    color: @sub_color;
  }
  .no_more_btn {
    width: 90%;
    margin: 2em auto;
    font-size: 1.6em;
    color: #fff;
    background-color: @main_color;
    text-align: center;
    padding: 0.6em 1em;
    box-sizing: border-box;
    border-radius: 2em;
  }
}
</style>
